module.exports = __webpack_public_path__ + "static-portal/img/49-1.5ebcc7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/49-1.jpg
// module id = YWP5
// module chunks = 4